import * as sterlingparker from './CompetitionList.styles.sterlingparker';
import * as volcanobet from './CompetitionList.styles.volcanobet';
import * as betprofessor from './CompetitionList.styles.betprofessor';
import * as junglebet from './CompetitionList.styles.junglebet';
import * as puntgenie from './CompetitionList.styles.puntgenie';
import * as fiestabet from './CompetitionList.styles.fiestabet';
import * as puntcity from './CompetitionList.styles.puntcity';
import * as betgalaxy from './CompetitionList.styles.betgalaxy';
import * as betroyale from './CompetitionList.styles.betroyale';
import * as juicybet from './CompetitionList.styles.juicybet';
import * as goldenrush from './CompetitionList.styles.goldenrush';
import * as vikingbet from './CompetitionList.styles.vikingbet';
import * as questbet from './CompetitionList.styles.questbet';
import * as wellbet from './CompetitionList.styles.wellbet';
import * as sugarcastle from './CompetitionList.styles.sugarcastle';
import * as oldgill from './CompetitionList.styles.oldgill';
import * as buffalobet from './CompetitionList.styles.buffalobet';
import * as titanbet from './CompetitionList.styles.titanbet';
import * as gigabet from './CompetitionList.styles.gigabet';
import * as slambet from './CompetitionList.styles.slambet';
import * as betstride from './CompetitionList.styles.betstride';
import * as templebet from './CompetitionList.styles.templebet';
import * as goldenbet888 from './CompetitionList.styles.goldenbet888';
import * as hyperbet from './CompetitionList.styles.hyperbet';
import * as bet777 from './CompetitionList.styles.bet777';
import * as chromabet from './CompetitionList.styles.chromabet';
import * as bet575 from './CompetitionList.styles.bet575';
import * as epicodds from './CompetitionList.styles.epicodds';
import * as pyramidbet from './CompetitionList.styles.pyramidbet';
import * as magnumbet from './CompetitionList.styles.magnumbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  volcanobet,
  betprofessor,
  junglebet,
  puntgenie,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
